export interface LocaleDef {
  code: string;
  label: string;
  english: string;
  currency: string;
  dir: 'ltr' | 'rtl';
}

export const locales: LocaleDef[] = [
  { code: 'en-TH', label: 'English', english: 'English', currency: 'THB', dir: 'ltr' },
  { code: 'th-TH', label: 'ไทย', english: 'Thai', currency: 'THB', dir: 'ltr' },
  { code: 'zh-CN', label: '中文', english: 'Chinese', currency: 'CNY', dir: 'ltr' },
  { code: 'ja-JP', label: '日本語', english: 'Japanese', currency: 'JPY', dir: 'ltr' },
  { code: 'ko-KR', label: '한국어', english: 'Korean', currency: 'KRW', dir: 'ltr' },
  { code: 'ru-RU', label: 'Русский', english: 'Russian', currency: 'RUB', dir: 'ltr' },
  { code: 'ar-AE', label: 'العربية', english: 'Arabic', currency: 'AED', dir: 'rtl' },
];

/** English is the complete dictionary; other locales override the highest-traffic strings. */
export const dictionary: Record<string, Record<string, string>> = {
  'en-TH': {
    'nav.discover': 'Find a chef',
    'nav.how': 'How it works',
    'nav.forChefs': 'For chefs',
    'nav.contact': 'Contact',
    'nav.signIn': 'Sign in',
    'nav.enter': 'Open my kitchen',
    'home.eyebrow': 'Private chefs in Bangkok, booked properly',
    'home.headline': 'A chef at your table, or dinner at your door.',
    'home.sub': 'Real menus, itemised prices in baht, no guessing what it will cost.',
    'home.searchWhere': 'Where',
    'home.searchWhen': 'When',
    'home.searchGuests': 'Guests',
    'home.searchCta': 'Show me chefs',
    'home.inHome': 'Cook at my place',
    'home.delivery': 'Cook & deliver',
    'common.perGuest': 'per guest',
    'common.perPortion': 'per portion',
    'common.from': 'from',
    'common.save': 'Save changes',
    'common.cancel': 'Cancel',
    'common.send': 'Send',
    'common.back': 'Back',
    'common.viewProfile': 'View profile',
    'common.message': 'Message',
    'common.request': 'Request a quote',
    'common.reviews': 'reviews',
    'app.inbox': 'Inbox',
    'app.bookings': 'Bookings',
    'app.saved': 'Saved chefs',
    'app.account': 'Account',
    'app.support': 'Support',
    'app.settings': 'Settings',
    'app.dashboard': 'Dashboard',
    'app.earnings': 'Earnings',
    'app.studio': 'My listing',
    'quote.title': 'Custom quote',
    'quote.accept': 'Accept & pay deposit',
    'quote.counter': 'Ask for changes',
    'quote.expires': 'Expires in',
    'quote.deposit': 'Deposit due now',
    'quote.balance': 'Balance after service',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
  },
  'th-TH': {
    'nav.discover': 'ค้นหาเชฟ',
    'nav.how': 'วิธีใช้งาน',
    'nav.forChefs': 'สำหรับเชฟ',
    'nav.contact': 'ติดต่อเรา',
    'nav.signIn': 'เข้าสู่ระบบ',
    'nav.enter': 'เข้าครัวของฉัน',
    'home.eyebrow': 'เชฟส่วนตัวในกรุงเทพฯ จองได้อย่างมั่นใจ',
    'home.headline': 'เชฟมาทำที่บ้านคุณ หรือส่งมื้อเย็นถึงประตู',
    'home.sub': 'เมนูจริง ราคาแยกเป็นรายการเป็นเงินบาท ไม่ต้องเดา',
    'home.searchWhere': 'ที่ไหน',
    'home.searchWhen': 'วันไหน',
    'home.searchGuests': 'จำนวนแขก',
    'home.searchCta': 'ดูเชฟ',
    'home.inHome': 'ทำที่บ้านฉัน',
    'home.delivery': 'ทำแล้วจัดส่ง',
    'common.perGuest': 'ต่อคน',
    'common.perPortion': 'ต่อชุด',
    'common.from': 'เริ่มต้น',
    'common.request': 'ขอใบเสนอราคา',
    'common.message': 'ส่งข้อความ',
    'common.viewProfile': 'ดูโปรไฟล์',
    'quote.title': 'ใบเสนอราคา',
    'quote.accept': 'ยอมรับและมัดจำ',
    'quote.counter': 'ขอแก้ไข',
    'quote.deposit': 'มัดจำที่ต้องชำระ',
    'quote.balance': 'ยอดคงเหลือหลังบริการ',
    'theme.light': 'สว่าง',
    'theme.dark': 'มืด',
  },
  'zh-CN': {
    'nav.discover': '寻找厨师',
    'nav.how': '如何运作',
    'nav.forChefs': '厨师入驻',
    'nav.contact': '联系我们',
    'nav.signIn': '登录',
    'nav.enter': '进入我的厨房',
    'home.eyebrow': '曼谷私厨，明码实价',
    'home.headline': '厨师上门，或把晚餐送到门口。',
    'home.sub': '真实菜单，逐项报价，不必猜价格。',
    'home.searchWhere': '地点',
    'home.searchWhen': '日期',
    'home.searchGuests': '人数',
    'home.searchCta': '查看厨师',
    'common.perGuest': '每位',
    'common.from': '起',
    'common.request': '索取报价',
  },
  'ja-JP': {
    'nav.discover': 'シェフを探す',
    'nav.how': '使い方',
    'nav.forChefs': 'シェフの方へ',
    'nav.contact': 'お問い合わせ',
    'nav.signIn': 'ログイン',
    'nav.enter': 'マイキッチン',
    'home.eyebrow': 'バンコクのプライベートシェフを、きちんと予約',
    'home.headline': 'シェフを食卓に。あるいは夕食を玄関に。',
    'home.sub': '実際のメニューと明細つきの料金。想像で払う必要はありません。',
    'home.searchWhere': 'エリア',
    'home.searchWhen': '日付',
    'home.searchGuests': '人数',
    'home.searchCta': 'シェフを見る',
    'common.perGuest': '1名あたり',
    'common.from': '〜',
    'common.request': '見積もりを依頼',
  },
  'ko-KR': {
    'nav.discover': '셰프 찾기',
    'nav.how': '이용 방법',
    'nav.forChefs': '셰프 지원',
    'nav.contact': '문의하기',
    'nav.signIn': '로그인',
    'nav.enter': '내 주방',
    'home.eyebrow': '방콕 프라이빗 셰프, 제대로 예약하기',
    'home.headline': '셰프가 집으로, 또는 저녁이 문앞으로.',
    'home.sub': '실제 메뉴와 항목별 견적. 추측할 필요 없습니다.',
    'home.searchWhere': '지역',
    'home.searchWhen': '날짜',
    'home.searchGuests': '인원',
    'home.searchCta': '셰프 보기',
    'common.perGuest': '1인당',
    'common.from': '부터',
    'common.request': '견적 요청',
  },
  'ru-RU': {
    'nav.discover': 'Найти шефа',
    'nav.how': 'Как это работает',
    'nav.forChefs': 'Для шефов',
    'nav.contact': 'Контакты',
    'nav.signIn': 'Войти',
    'nav.enter': 'Моя кухня',
    'home.eyebrow': 'Частные шефы в Бангкоке — понятное бронирование',
    'home.headline': 'Шеф за вашим столом или ужин у вашей двери.',
    'home.sub': 'Настоящие меню и постатейные цены. Без догадок.',
    'home.searchWhere': 'Где',
    'home.searchWhen': 'Когда',
    'home.searchGuests': 'Гости',
    'home.searchCta': 'Показать шефов',
    'common.perGuest': 'за гостя',
    'common.from': 'от',
    'common.request': 'Запросить смету',
  },
  'ar-AE': {
    'nav.discover': 'ابحث عن طاهٍ',
    'nav.how': 'كيف يعمل',
    'nav.forChefs': 'للطهاة',
    'nav.contact': 'اتصل بنا',
    'nav.signIn': 'تسجيل الدخول',
    'nav.enter': 'مطبخي',
    'home.eyebrow': 'طهاة خاصون في بانكوك، بحجز واضح',
    'home.headline': 'طاهٍ على مائدتك، أو عشاء على بابك.',
    'home.sub': 'قوائم حقيقية وأسعار مفصّلة، دون تخمين.',
    'home.searchWhere': 'المكان',
    'home.searchWhen': 'التاريخ',
    'home.searchGuests': 'عدد الضيوف',
    'home.searchCta': 'اعرض الطهاة',
    'common.perGuest': 'للفرد',
    'common.from': 'من',
    'common.request': 'اطلب عرض سعر',
  },
};
